export class CnResults {
    values() {
        return [];
    }

    loaded() {
        return false;
    }
}